module.exports = __webpack_public_path__ + "flyer_background_ocean_sunset_118-7f9b0a8a22a74b225cc0d9ac8d02caea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_ocean_sunset_118.jpg
// module id = 1668
// module chunks = 1